import { useStore } from '@assets/model/Store';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { DraggableSplit } from '../DraggableSplit/DraggableSplit';
import { ProjectFiles } from '../ProjectFiles/ProjectFiles';
import { Switch } from '../Switch/Switch';
import { ChatPanel } from './ChatPanel/ChatPanel';
import { FileViewerPanel } from '../FileViewerPanel/FileViewerPanel';
import { url } from 'inspector';
export const ChatPage = observer(() => {
    const [view, setView] = useState(0);
    const [backOffset, setBackoffset] = useState(0);
    const [fileData, setViewFileURL] = useState({
        url: null,
        displayName: null
    });

    const store = useStore();
    const query = store.query;
    const requestSeeFile = (fileUrl: string, displayName: string) => {
        setViewFileURL({ url: fileUrl, displayName: displayName });

        if (fileUrl.indexOf('.pdf') > -1) {
            setBackoffset(80);
        } else {
            setBackoffset(20);
        }

        setView(1);
    };

    return (
        <DraggableSplit spaceBetween={30}>
            <Switch
                activeView={view}
                backButtonOffset={backOffset}
                onBack={() => setView(0)}
            >
                <ProjectFiles requestSeeFile={requestSeeFile} />
                <FileViewerPanel
                    fileName={fileData.url}
                    title_display={fileData.displayName}
                />
            </Switch>
            <ChatPanel />
        </DraggableSplit>
    );
});
